import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledAutoWDConfirmationModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  text-align: center;
  height: 85vh;
  ${themeMedia.tablet`
        height: 100%;
        justify-content: center;    
    `}
`
export const StyledAutoWDConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.5rem;
  gap: 2.5rem;
  ${themeMedia.tablet`
        margin: 1rem 0 2rem 0;
        gap: 2rem;   
        
    `}
`

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`
